import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRightIcon = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.1 12L7.5 7.4L8.9 6L14.9 12L8.9 18L7.5 16.6L12.1 12Z" }));
const ForwardRef = forwardRef(SvgChevronRightIcon);
export default ForwardRef;
